/**
 * WCAG 2.5.5 / Spec ≥44×44 CSS px touch target (VCL C4).
 *
 * Aligns with `max(44px, var(--vcl-control-height-md))` so hit geometry tracks
 * the control-height family (live md = 2.5rem → computed 44px floor).
 * Prefer these local classes on call sites over changing shared Button for all surfaces.
 */

/** Height-only floor — text links / rows that must not force square min-width. */
export const CUSTOMER_MIN_TOUCH_HEIGHT_CLASS =
  'min-h-[max(44px,var(--vcl-control-height-md))]';

/**
 * Square ≥44 hit target (icon buttons, chip peers).
 * Measurement: max(44px, --vcl-control-height-md) at baseline = **44px**.
 */
export const CUSTOMER_MIN_TOUCH_TARGET_CLASS = [
  'h-[max(44px,var(--vcl-control-height-md))]',
  CUSTOMER_MIN_TOUCH_HEIGHT_CLASS,
  'min-w-[max(44px,var(--vcl-control-height-md))]',
].join(' ');

/** Explicit primary CTA geometry (C4 / AC-07) — pair with Button size lg (≥48). */
export const CUSTOMER_PRIMARY_CTA_MIN_CLASS =
  'min-h-[max(48px,var(--vcl-control-height-lg))] h-[max(48px,var(--vcl-control-height-lg))]';

/** C6 control radius — alias live `--radius-sm` via `--vcl-control-radius-sm`. */
export const CUSTOMER_CONTROL_RADIUS_SM_CLASS =
  'rounded-[var(--vcl-control-radius-sm)]';

/** C6 control radius md — alias live `--radius-md` via `--vcl-control-radius-md`. */
export const CUSTOMER_CONTROL_RADIUS_MD_CLASS =
  'rounded-[var(--vcl-control-radius-md)]';
